(function () {'use strict';}());
angular.module("app").directive('achievementView', function($document,$timeout, AppService) {
	return {
	  restrict: 'A',
	  templateUrl: 'views/achievements.html?version=1.0',

	  link:function($scope,element,attr)
	  {
	    var trace = angular.trace;
	    var badges = AppService.badges || $scope.badges;
	    
	    $scope.firsts = badges.filter(filterBadges, {type: "first"});
	    $scope.progress = badges.filter(filterBadges, {type: "progress"});
	    $scope.milestones = badges.filter(filterBadges, {type: "milestone"});
	    $scope.count = badges.filter(filterBadges, {type: "count"});

	    function filterBadges(e) {
	    	return e.type === this.type;
	    }
	  }  
	};
});
